import { render } from "./AssetComponent.vue?vue&type=template&id=465329c1"
import script from "./AssetComponent.vue?vue&type=script&lang=js"
export * from "./AssetComponent.vue?vue&type=script&lang=js"

import "./AssetComponent.vue?vue&type=style&index=0&id=465329c1&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__